import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useNavigate } from 'react-router-dom';

const StandardPageHeader = ({ title, subtitle, actions = null, backTo = null, backLabel = 'Volver', sx = {} }) => {
  const navigate = useNavigate();

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      spacing={1.5}
      sx={{ mb: 2.5, ...sx }}
    >
      <Box sx={{ minWidth: 0 }}>
        {backTo && (
          <Button
            onClick={() => navigate(backTo)}
            startIcon={<ArrowBackOutlinedIcon />}
            size="small"
            sx={{ ml: -1, mb: 0.5, color: 'text.secondary', textTransform: 'none' }}
          >
            {backLabel}
          </Button>
        )}
        <Typography variant="h2" color="text.primary">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>

      {actions && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={1}
          sx={{ width: { xs: '100%', md: 'auto' }, flexWrap: 'wrap' }}>
          {actions}
        </Stack>
      )}
    </Stack>
  );
};

export default StandardPageHeader;
